/**
 * Whether an image's caption box is shown on the slide.
 *
 * The caption text itself stays on the block when it is switched off — an
 * author who only wants the APA note on the slide should not lose the caption
 * they wrote, and it still comes back if they switch it on again. Every surface
 * that paints a caption (renderers, HTML export, PowerPoint, PDF) reads it
 * through here so "hidden" means hidden everywhere.
 *
 * The flag is opt-out: a block saved before it existed has no
 * `imageShowCaption`, and must keep showing its caption.
 */

export const isImageCaptionHidden = (item) => item?.imageShowCaption === false;

export const getDisplayCaption = (item) => (isImageCaptionHidden(item) ? '' : (item?.caption || ''));
